import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router";
import { Icon } from "./Icon.tsx";

/**
 * Back to where the player came from (Live, an execution, a list…) when they came
 * from inside the app; otherwise to the fallback page. With `from`, back only when the
 * link that opened this page said it came from there (`state: { from }`): a page above
 * in the app's tree (the matches list over a match) is the way back from anywhere else.
 */
export function BackLink({ fallback, fallbackLabel, from }: { fallback: string; fallbackLabel: string; from?: string }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  // "default" is the first page of the visit: nothing of ours to go back to.
  const cameFrom = (location.state as { from?: unknown } | null)?.from;
  if (from ? cameFrom === from && location.key !== "default" : location.key !== "default")
    return (
      <button type="button" className="back-link" onClick={() => navigate(-1)}>
        <Icon name="chevronLeft" size={16} />
        {t("common.back")}
      </button>
    );
  return (
    <Link to={fallback} className="back-link">
      <Icon name="chevronLeft" size={16} />
      {fallbackLabel}
    </Link>
  );
}
